import { render, staticRenderFns } from "./History.vue?vue&type=template&id=aa4ea6d8"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"
import style0 from "./History.vue?vue&type=style&index=0&id=aa4ea6d8&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa4ea6d8')) {
      api.createRecord('aa4ea6d8', component.options)
    } else {
      api.reload('aa4ea6d8', component.options)
    }
    module.hot.accept("./History.vue?vue&type=template&id=aa4ea6d8", function () {
      api.rerender('aa4ea6d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/History.vue"
export default component.exports